export default __webpack_public_path__ + "static/univers-roman-e395046abf51b8f461ae168bb8a5e84f.woff2";